import type { MovementRequest } from '../pages/folders/movement';
import type { FolderMoveWaitDialogRequest } from './folderMoveWaitDialogRequest';
import { requestDialog } from './requestDialog';

export function showFolderMoveWaitDialog(movementRequests: MovementRequest[]) {
  const req: FolderMoveWaitDialogRequest = {
    movementRequests,
  };
  requestDialog(req, () => import('@mimir/web/components/Common/Dialogs/dialogs/MoveFolderContentDialog.vue'));
}
